import React, { useContext, useState, useEffect, useCallback, useRef } from 'react';
import Image from "next/image";
import Link from '../components/custom/Link';
import { useRouter } from 'next/router';
import { CurrencyContext } from "../contexts/CurrencyContext";
import { CartContext } from '../contexts/CartContext';
import { UserContext } from '../contexts/UserContext';
import { ThemeContext } from '../contexts/ThemeContext';
import CustomPopup from '../components/CustomPopup'; // Import CustomPopup
import { useJobId } from '../contexts/ContextJbo';
import { useAxios } from "../utils/axios";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { FaShoppingCart, FaCheckCircle, FaTimes } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { setImageSrc } from '../utils/config';
import LoadingAnimation from '../components/custom/LoadingAnimation';
import cartProducts from './jsondatas/cartProducts.json';
import Custom404 from '../pages/404';
import getRedisClient from '../utils/redis';
import getRedisClientLocal from '../utils/localredis';
import errorLogApi from '../components/custom/ErrorLogApi';
import useTracking from '../components/custom/useTracking';

/**
 * Cart Component
 * A React component for displaying items in the cart, managing cart functionalities like removing items,
 * applying promo codes, and calculating the total price.
 * It uses context for cart and currency information and Axios for API requests.
 */

const Cart = () => {
  const axios = useAxios();
  const { cart, TaxAmount, TotalAmount, Totaldiscount, setLoading,setTotalDiscount,setPrevilegeCardData,previlageCardData, promoMessageData, promoStatusData, TotalQuantity, fetchCart, removeFromCart, cartTotal, TotalPrice, loading, errorstate,previlegeCardStatus } = useContext(CartContext);
  const { formatCurrency, currentCurrency } = useContext(CurrencyContext);
  const theme = useContext(ThemeContext);
  const { userDetails, userId } = useContext(UserContext);
  const userType = userDetails?.user_type || 0;

  
  const promoCodeData = sessionStorage.getItem("promocode");
  const { jboId } = useJobId();
  const router = useRouter();
  const trackPage = useTracking('Cart Page');
  const [totalPrice, setTotalPrice] = useState(0);
  const [promoCode, setPromoCode] = useState(sessionStorage.getItem("promocode") || '');
  const [finalPrice, setFinalPrice] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false); // State to handle popup visibility
  const [popupConfig, setPopupConfig] = useState({}); // State to handle popup configuration

  useEffect(() => {
    if (theme.siteStatus === 1) {
      fetchCart();
      trackPage();
    }
  }, []);

  useEffect(() => {
    let total = 0;
    for (let product of cart) {
      total += product.actual_price;
    }
    setTotalPrice(total);
  }, [cart]);

  const handleRemove = (product) => {
    const productToRemove = {
      id: product.product_id,
      ...product
    };
    removeFromCart(productToRemove);
  };

  const handlePromoCodeChange = (event) => {
    setPromoCode(event.target.value);
  };

 
{/* promo code function - 28/08/2024 */}
  const handlePromoCodeSubmit = async () => {
    
  
    const prevStatus = sessionStorage.getItem("prev_status_check");
  
    if (prevStatus == 1) {
      // Show popup to remove privilege card before applying promo code
      setPopupConfig({
        type: 'info',
        title: 'Remove Privilege Card',
        subText: 'Please remove the Privilege Card before applying a Promo Code.',
        onConfirm: closePopup,
        onClose: closePopup,
        showConfirmButton: false,
        showCancelButton: false,
        autoClose: 3,
      });
      setIsPopupOpen(true);
      return
    }
    setTotalDiscount(null);
    try {
      const productIds = cart.map(product => product.product_id);
      const payload = {
        privilege_card_status : 2,
        promo_code: promoCode,
        product_id: productIds,
        user_id: userId,
        currency: currentCurrency,
       
      };
  
      const response = await axios.post('promocode/JpencilPromocodeVerify', payload)
        .then((res) => {
        if(res.data.status == 1){
          sessionStorage.setItem('status',2)
        }
          sessionStorage.setItem("promoStatusCheck", res.data.status);
          sessionStorage.setItem("promocode", promoCode);
          sessionStorage.setItem("promo_message", res.data.msg);
          fetchCart();
          setFinalPrice(res.data.total_price);
          sessionStorage.setItem("promo_final_price", res.data.total_price);
        })
        .catch((err) => {
          // Handle error
        });
    } catch (error) {
      setTotalDiscount(null);
      // Handle error
    }
  };
  {/* previlage card function - 28/08/2024 */}
  const handlePrivelageCardSubmit = async () => {

  
    const promoStatus = sessionStorage.getItem("promoStatusCheck");
  
    if (promoStatus == 1) {
      // Show popup to remove promo code before applying privilege card
      setPopupConfig({
        type: 'info',
        title: 'Remove Promo Code',
        subText: 'Please remove the Promo Code before applying a Privilege Card.',
        onConfirm: closePopup,
        onClose: closePopup,
        showConfirmButton: false,
        showCancelButton: false,
        autoClose: 3,
      });
      setIsPopupOpen(true);
     
     return
    }
    setTotalDiscount(null);
    try {
      const productIds = cart.map(product => product.product_id);
      const payload = {
        privilege_card_status : 1,
        promo_code: sessionStorage.getItem("previlageCardvalue") ,
        product_id: productIds,
        user_id: userId,
        currency: currentCurrency,
      
      };
  
      const response = await axios.post('promocode/JpencilPromocodeVerify', payload)
        .then((res) => {
          console.log('res.data.status',res.data.status);
          if(res.data.status == 1){
            sessionStorage.setItem('status',1)
            setPrevilegeCardData(1);
          }
          else{
            setPrevilegeCardData(2);
            sessionStorage.setItem("prev_status_check", res.data.status);
            sessionStorage.setItem("prev_promo_message", res.data.msg);
          }
          sessionStorage.setItem("prev_status_check", res.data.status);
          sessionStorage.setItem("prev_promo_message", res.data.msg);

          fetchCart();
          setFinalPrice(res.data.total_price);
          sessionStorage.setItem("prev_final_price", res.data.total_price);
        })
        .catch((err) => {
          // Handle error
        });
    } catch (error) {
      setTotalDiscount(null);
      // Handle error
    }
  };
  const closePopup = () => {
    setIsPopupOpen(false);
  };
// for preview pop up modal
  const handleDisabledClick = (event) => {
    event.preventDefault();
    setPopupConfig({
      type: 'info',
      title: 'Preview Mode',
      subText: 'Actions like "Remove Cart" are disabled during preview.',
      onConfirm: closePopup,
      onClose: closePopup,
      showConfirmButton: false,
      showCancelButton: false,
      autoClose: 3,
    });
    setIsPopupOpen(true);
  };
 
  const handleDisabledClick1 = (event) => {
    event.preventDefault();
    setPopupConfig({
      type: 'info',
      title: 'Preview Mode',
      subText: 'Actions like Promo code Apply are disabled during preview.',
      onConfirm: closePopup,
      onClose: closePopup,
      showConfirmButton: false,
      showCancelButton: false,
      autoClose: 3,
    });
    setIsPopupOpen(true);
  };

  const handleDisabledClickImage = (event) => {
    event.preventDefault();
    setPopupConfig({
      type: 'info',
      title: 'Preview Image',
      subText: 'Product details are disabled in this preview. However, you can view product details on the product listing page.',
      onConfirm: closePopup,
      onClose: closePopup,
      showConfirmButton: false,
      showCancelButton: false,
      autoClose: 3,
    });
    setIsPopupOpen(true);
  };

  if (loading && theme.siteStatus === 1) {
    return <LoadingAnimation />;
  }

  const products = theme.siteStatus === 0 ? cartProducts.product : cart;

  const totalWeight = products.reduce((total, product) => {
    return total + (product.json && product.json.weight ? product.json.weight : 0);
  }, 0);

  if (errorstate) {
    return <Custom404 />;
  }
  if (products.length === 0) {
    return (
      <>
        <div className="xl:container mx-auto px-4 py-1 font-body flex justify-center">
          <Image
            src="https://img.freepik.com/premium-vector/shopping-cart-with-cross-mark-wireless-paymant-icon-shopping-bag-failure-paymant-sign-online-shopping-vector_662353-912.jpg"
            alt="Empty Cart"
            className="object-contain"
            width={626} // Set appropriate width based on the image URL or your requirements
            height={417} // Set appropriate height based on the image URL or your requirements
          />
        </div>
        <div className="text-center mt-4">
          <p className="text-lg text-gray-600">Your cart is currently empty.</p>
        </div>
      </>
    );
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
  };

  const childVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeInOut",
      },
    },
  };

  return (
    <>
      <div className="xl:container px-4 py-4 flex justify-between">
        <div className="flex gap-3 items-center">
          <Link href="/" className="text-primary text-base">
            <i className="fas fa-home"></i>
          </Link>
          <div className="flex gap-3 items-center mt-1">
            <span className="text-sm text-gray-500">
              <i className="fas fa-chevron-right "></i>
            </span>
            <p className="text-gray-500  font-medium uppercase">Shopping Cart</p>
          </div>
        </div>
      </div>

      <div className="sm:hidden">
        <div className="block xl:container lg:grid grid-cols-12 gap-6 items-start pb-16 pt-4">
          <div className='xl:col-span-9 lg:col-span-8 '>
            <div className="bg-gray-200 py-2 pl-12 pr-20 xl:pr-28 mb-4 hidden md:flex">
              <p className="text-gray-600 text-center">Product </p>
              <p className="text-gray-600 text-center ml-auto mr-16 xl:mr-24">Quantity </p>
            </div>
            <div className='space-y-4'>
              {products.map((product) => (
                <div key={product.product_id} className="flex items-center justify-between gap-4 p-4 shadow-sm">
                  <div className="w-1/3 flex-shrink-0">
                    <Link href={`${product.url}`} onClick={theme.siteStatus === 0 ? handleDisabledClickImage : undefined}>
                    <Image
    onLoad={(e) => e.target.classList.remove("shimmer")}
    src={setImageSrc(product.json.Images, product.json['Product Name'], 's400')}
    alt={product.json['Product Name']}
    width={300} // Set appropriate width
    height={300} // Set appropriate height
    className="w-full shimmer rounded-lg transition duration-500 transform group-hover:scale-110 cursor-pointer"
  />
                    </Link>
                  </div>
                  <div className="w-2/3">
                    <h2 className="text-gray-800 mb-1 sm:text-sm md:text-md lg:text-lg xl:text-xl font-medium uppercase">
                      {product.json['Product Name']}
                    </h2>
                    {/* {product.json['weight'] && <motion.h2 className="text-lg text-primary font-semibold" variants={childVariants}>Weight : {product.json['weight']} gms</motion.h2>} */}
                    <div className="pt-1">
                      <div className="flex items-baseline gap-2">
                           {/* status based rendering - 28/08/2024 */}
                        {(sessionStorage.getItem('promoStatusCheck') == 1 || sessionStorage.getItem('prev_status_check') == 1) && theme.siteStatus === 1 && <motion.p variants={childVariants} className="text-sm line-through text-gray-500">{formatCurrency(product.selling_price)}</motion.p>}
                       {/* Price rule Added 04/09/24 */}
                        <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 items-start sm:items-center text-lg mb-2">
                    <h3 className="font-bold text-md xl:text-xl text-gray-700 mb-2 ">
                        {
                          ((product.special_price_status == 1) && (userType == 1 || userType == 0)) ? (
                            <>
                            <motion.p variants={childVariants}>
                            <span className="text-green-700 text-md md:text-xl ">{formatCurrency(product.special_amount)} </span>
                               <span className="ml-2 line-through text-red-500 text-sm md:text-lg">{formatCurrency(product.actual_price)} </span>
                            </motion.p>                        
                            </>

                          ) : (<motion.p variants={childVariants} className="text-lg font-semibold text-primary">{formatCurrency(product.actual_price)}</motion.p>)
                        }
                      </h3>
                      </div>                       </div>
                      <div className="flex">
                        {(sessionStorage.getItem('promoStatusCheck') == 1 || sessionStorage.getItem('prev_status_check') == 1) && <motion.p variants={childVariants} className="text-md text-primary">
                          <span className='font-bold'> You Saved</span> : {formatCurrency(product.discount)}
                        </motion.p>}
                        <div className="h-8 w-10 flex gap-4 items-center justify-center text-xs md:text-base rounded-md">
                          <div className="text-gray-600 flex items-center justify-center hover:text-primary cursor-pointer"
                            onClick={(event) => theme.siteStatus !== 0 ? handleRemove(product) : handleDisabledClick(event)}
                          >
                            <i className="fas fa-trash"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className='xl:col-span-3 sticky top-[100px] lg:col-span-4 lg:border lg:border-gray-200 px-4 py-4 rounded mt-6 lg:mt-0'>
            <h3 className='text-gray-800 text-lg mb-4 font-medium uppercase'>Order Summary</h3>
            <div className='space-y-1 text-gray-600 pb-3 border-b border-gray-200'>
              <div className='flex justify-between font-medium'>
                <p>Total Amount (Before Tax)</p>
                <p>{theme.siteStatus === 0 ? formatCurrency(385246) : formatCurrency(TotalAmount)}</p>
              </div>
              {/* {totalWeight && <div className='flex justify-between font-medium'>
                <p>Total Weight</p>
                <p>{totalWeight}gms</p>
              </div>} */}
              {(sessionStorage.getItem('promoStatusCheck') == 1 || sessionStorage.getItem('prev_status_check') == 1) && theme.siteStatus === 1 && (
                <div className='flex justify-between font-medium'>
                  <p>Discount</p>
                  <p>{formatCurrency(Totaldiscount)}</p>
                </div>
              )}
              <div className='flex justify-between font-medium'>
                <p>Tax</p>
                <p>{theme.siteStatus === 0 ? formatCurrency(16750) : formatCurrency(TaxAmount)}</p>
              </div>
            </div>
            <div className='flex justify-between my-3 text-gray-800 font-semibold uppercase'>
              <h3>Grand Total</h3>
              {theme.siteStatus === 0
                ? <span>{formatCurrency(401996)}</span>
                : <span>{formatCurrency(TotalPrice)}</span>}
            </div>
{/* previlage card conditional rendering - 28/08/2024 */}
            {previlegeCardStatus == 1 && (
  <div className='mb-4'>
    {/* Title above the input box */}
    <h3 className='text-sm font-medium mb-2'>
      Privilege Card
    </h3>
    
    <div className='flex'>
      <input
        type="text"
        className='pl-4 w-full border border-r-0 border-primary py-2 px-3 rounded-l-md focus:ring-primary focus:border-primary text-sm'
        placeholder='Privilege Card'
        value={sessionStorage.getItem("previlageCardvalue") || ''} // Show the privilege card value if it exists
        readOnly // Make the input read-only since we're not changing it
      />
      {(sessionStorage.getItem("previlageCardvalue") && sessionStorage.getItem("prev_status_check") == "1")
        ? <button
            type="submit"
            className='bg-primary border border-primary text-white px-5 font-medium rounded-r-md transition text-sm w-full block text-center'
            onClick={() => {
              sessionStorage.removeItem("prev_status_check");
              sessionStorage.removeItem("prev_promo_message");
              sessionStorage.removeItem("prev_final_price");
              window.location.reload();
            }}
          >
            Remove
          </button>
        : <button
            type="submit"
            className='bg-primary border border-primary text-white px-5 font-medium rounded-r-md transition text-sm w-full block text-center'
            onClick={handlePrivelageCardSubmit} // Use the appropriate handler
          >
            Apply
          </button>
      }
    </div>
  </div>
)}
{/* privilege card note */}
{previlegeCardStatus == 1 && <div className="mb-4">
    <p className="text-sm">
      * Apply your privilege card by clicking Apply and claim your privilege offer!
    </p>
    </div>}
{/* message display for previlege - 28/08/2024 */}
{sessionStorage.getItem('prev_status_check') !== null && sessionStorage.getItem('prev_status_check') !== undefined && (
  sessionStorage.getItem('prev_status_check') == 0 ? 
  <div className="text-white px-4 py-2 border-0 rounded relative mb-4 mt-4 bg-red-400">
    <span className="text-xl inline-block mr-5 align-middle">
      <i className="fas fa-exclamation-circle"></i>
    </span>
    <span className="inline-block align-middle mr-8">
      {sessionStorage.getItem("prev_promo_message")} ({sessionStorage.getItem("previlageCardvalue")})
    </span>
  </div> : 
  sessionStorage.getItem('prev_status_check') == 1 ? 
  <div className="text-white px-4 py-2 border-0 rounded relative mb-4 mt-4 bg-green-400">
    <span className="text-xl inline-block mr-5 align-middle">
      <i className="fas fa-check-circle"></i>
    </span>
    <span className="inline-block align-middle mr-8">
      {sessionStorage.getItem("prev_promo_message")} ({sessionStorage.getItem("previlageCardvalue")})
    </span>
  </div> 
  : null
)}


<div className='mb-4'>
  {/* Title above the Promo Code input box */}
  <h3 className='text-primary text-center font-medium mb-2'>
    Promo Code
  </h3>
  
  <div className='flex'>
    <input
      type="text"
      className='pl-4 w-full border border-r-0 border-primary py-2 px-3 rounded-l-md focus:ring-primary focus:border-primary text-sm'
      placeholder='Coupon'
      value={promoCode}
      onChange={handlePromoCodeChange}
    />
    {sessionStorage.getItem("promoStatusCheck") == 1
      ? <button
          type="submit"
          className='bg-primary border border-primary text-white px-5 font-medium rounded-r-md transition text-sm w-full block text-center'
          onClick={() => {
            sessionStorage.removeItem("promocode");
            sessionStorage.removeItem("promo_final_price");
            sessionStorage.removeItem("discount");
            // promostatus removed when clear - 29/08/2024
            sessionStorage.removeItem("promoStatusCheck");
            sessionStorage.removeItem("promo_message");
            window.location.reload();
          }}
        >
          Remove
        </button>
      : <button
      type="submit"
      className={`bg-primary border border-primary text-white px-5 font-medium rounded-r-md transition text-sm w-full block text-center ${!promoCode ? 'opacity-50 cursor-not-allowed' : ''}`}
      onClick={(event) => theme.siteStatus !== 0 ? handlePromoCodeSubmit(event) : handleDisabledClick1(event)}
      disabled={!promoCode} 
    >
      Apply
    </button>}
  </div>
</div>
{/* message display for promocode - 28/08/2024 */}
{sessionStorage.getItem('promoStatusCheck') !== null && sessionStorage.getItem('promoStatusCheck') !== undefined && (
  sessionStorage.getItem('promoStatusCheck') == 0 ? 
  <div className="text-white px-4 py-2 border-0 rounded relative mb-4 mt-4 bg-red-400">
    <span className="text-xl inline-block mr-5 align-middle">
      <i className="fas fa-exclamation-circle"></i>
    </span>
    <span className="inline-block align-middle mr-8">
      {sessionStorage.getItem("promo_message")} ({promoCodeData})
    </span>
  </div> : 
  sessionStorage.getItem('promoStatusCheck') == 1 ? 
  <div className="text-white px-4 py-2 border-0 rounded relative mb-4 mt-4 bg-green-400">
    <span className="text-xl inline-block mr-5 align-middle">
      <i className="fas fa-check-circle"></i>
    </span>
    <span className="inline-block align-middle mr-8">
      {sessionStorage.getItem("promo_message")} ({promoCodeData})
    </span>
  </div> 
  : null
)}
            <Link href="checkout/Checkout" className='bg-primary border border-primary text-white px-4 py-3 font-medium rounded-md uppercase hover:bg-transparent hover:text-primary transition text-sm w-full block text-center'>
              Process to checkout
            </Link>
          </div>
        </div>
      </div>

      <div className="hidden sm:block">
        <div className="block xl:container px-4 lg:grid grid-cols-12 gap-6 items-start pb-16 pt-4">
          <div className='xl:col-span-8 lg:col-span-8 bg-white p-6 rounded-md border border-gray-200'>
            <div className="flex items-center justify-between mb-6 border-b pb-3">
              <div className="flex items-center">
                <div className="mr-3 text-xl text-primary">
                  <FaShoppingCart />
                </div>
                <p className="text-xl font-semibold">Shopping Cart</p>
              </div>
            </div>
            <motion.div className="space-y-6" variants={containerVariants} initial="hidden" animate="visible">
              {products.map((product, index) => (
                <div key={product.product_id} className="flex items-center justify-between border-b pb-4">
                  <Link href={product.url} className="flex items-center">
                    <Link href={`${product.url}`} onClick={theme.siteStatus === 0 ? handleDisabledClickImage : undefined}>
                      <motion.img
                        src={setImageSrc(product.json.Images, product.json['Product Name'], 's400')}
                        alt={product.json['Product Name']}
                        className="cursor-pointer w-36 h-36 object-cover rounded-md mr-4"
                        variants={childVariants}
                      />
                    </Link>
                    <div className='flex flex-col gap-2'>
                      <motion.h1 className="text-lg text-primary font-semibold" variants={childVariants}>{product.json['Product Name']}</motion.h1>
                      {/* {product.json['weight'] && <motion.h2 className="text-lg text-primary font-semibold" variants={childVariants}>Weight : {product.json['weight']} gms</motion.h2>} */}
                      <div className="flex items-baseline gap-2">
                           {/* status based rendering - 28/08/2024 */}
                        {(sessionStorage.getItem('promoStatusCheck') == 1 || sessionStorage.getItem('prev_status_check') == 1)  && theme.siteStatus === 1 && <motion.p variants={childVariants} className="text-sm line-through text-gray-500">{formatCurrency(product.selling_price)}</motion.p>}
                       {/* Price rule Added 04/09/24 */}
                        <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 items-start sm:items-center text-lg mb-2">
      <h3 className="font-bold text-md xl:text-xl text-gray-700 mb-2">
        {(product.special_price_status == 1 && (userType == 1 || userType == 0)) ? (
          <motion.p variants={childVariants}>
                 <span className="text-green-700 text-md md:text-xl">
              {formatCurrency(product.special_amount)}
            </span>
            <span className="ml-2 line-through text-red-500 text-sm md:text-lg">
              {formatCurrency(product.actual_price)}
            </span>
       
          </motion.p>
        ) : (
          <motion.p variants={childVariants} className="text-lg font-semibold text-primary">
            {formatCurrency(product.actual_price)}
          </motion.p>
        )}
      </h3>
    </div>                      </div>
                         {/* status based rendering - 28/08/2024 */}
                      { (sessionStorage.getItem('promoStatusCheck') == 1 || sessionStorage.getItem('prev_status_check') == 1) && theme.siteStatus === 1 && <motion.p variants={childVariants} className="text-md text-primary">
                        <span className='font-bold'> You Saved</span> : {formatCurrency(product.discount)}
                      </motion.p>}
                    </div>
                  </Link>
                  <div className="flex justify-end items-end mt-8">
                    <motion.button
                      className="bg-transparent hover:bg-red-500 text-red-500 hover:text-white font-semibold py-2 px-4 border border-red-600 hover:border-transparent rounded flex items-center justify-center gap-2"
                      onClick={(event) => theme.siteStatus !== 0 ? handleRemove(product) : handleDisabledClick(event)}
                      variants={childVariants}
                    >
                      Remove
                      <i className="fas fa-trash"></i>
                    </motion.button>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>
          <div className='xl:col-span-4 lg:col-span-4 sticky top-[100px] border border-gray-200 px-4 py-4 rounded mt-6 lg:mt-0'>
            <h3 className='text-gray-800 text-lg mb-4 font-medium uppercase'>Order Summary</h3>
            <div className='space-y-1 text-gray-600 pb-3 border-b border-gray-200'>
              <div className='flex justify-between font-medium'>
                <p>Total Amount (Before Tax)</p>
                <p>{theme.siteStatus === 0 ? formatCurrency(385246) : formatCurrency(TotalAmount)}</p>
              </div>
              {/* {totalWeight && <div className='flex justify-between font-medium'>
                <p>Total Weight</p>
                <p>{totalWeight} gms</p>
              </div>} */}
                 {/* status based rendering - 28/08/2024 */}
              {(sessionStorage.getItem('promoStatusCheck') == 1 || sessionStorage.getItem('prev_status_check') == 1) && theme.siteStatus === 1 && (
                <div className='flex justify-between font-medium'>
                  <p>Discount</p>
                  <p>{formatCurrency(Totaldiscount)}</p>
                </div>
              )}
              <div className='flex justify-between font-medium'>
                <p>Tax</p>
                <p>{theme.siteStatus === 0 ? formatCurrency(16750) : formatCurrency(TaxAmount)}</p>
              </div>
            </div>
            <div className='flex justify-between my-3 text-gray-800 font-semibold uppercase'>
              <h3>Grand Total</h3>
              {theme.siteStatus === 0
                ? <span>{formatCurrency(401996)}</span>
                : <span>{formatCurrency(TotalPrice)}</span>}
            </div>
{/* previlage card conditional rendering - 28/08/2024 */}
            {previlegeCardStatus == 1 && (
  <div className='mb-4'>
    {/* Title above the input box */}
    <h2 className='text-primary font-medium mb-2 text-center'>
      Privilege Card
    </h2>
    
    <div className='flex'>
      <input
        type="text"
        className='pl-4 w-full border border-r-0 border-primary py-2 px-3 rounded-l-md focus:ring-primary focus:border-primary text-sm'
        placeholder='Privilege Card'
        value={sessionStorage.getItem("previlageCardvalue") || ''} // Show the privilege card value if it exists
        readOnly // Make the input read-only since we're not changing it
      />
      {(sessionStorage.getItem("previlageCardvalue") &&  sessionStorage.getItem("prev_status_check") == "1")
        ? <button
            type="submit"
            className='bg-primary border border-primary text-white px-5 font-medium rounded-r-md transition text-sm w-full block text-center'
            onClick={() => {
              sessionStorage.removeItem("prev_status_check");
              sessionStorage.removeItem("prev_promo_message");
              sessionStorage.removeItem("prev_final_price");
              window.location.reload();
            }}
          >
          Remove
          </button>
        : <button
            type="submit"
            className='bg-primary border border-primary text-white px-5 font-medium rounded-r-md transition text-sm w-full block text-center'
            onClick={handlePrivelageCardSubmit} 
          >
            Apply
          </button>
      }
    </div>
  </div>
)}
 {/* privilege card note */}
 {previlegeCardStatus == 1 && <div className="mb-4">
    <p className="text-sm">
      * Apply your privilege card by clicking Apply and claim your privilege offer!
    </p>
    </div>}
{/* message display for previlege - 28/08/2024 */}
{sessionStorage.getItem('prev_status_check') !== null && sessionStorage.getItem('prev_status_check') !== undefined && (
  sessionStorage.getItem('prev_status_check') == 0 ? 
  <div className="text-white px-4 py-2 border-0 rounded relative mb-4 mt-4 bg-red-400">
    <span className="text-xl inline-block mr-5 align-middle">
      <i className="fas fa-exclamation-circle"></i>
    </span>
    <span className="inline-block align-middle mr-8">
      {sessionStorage.getItem("prev_promo_message")} ({sessionStorage.getItem("previlageCardvalue")})
    </span>
  </div> : 
  sessionStorage.getItem('prev_status_check') == 1 ? 
  <div className="text-white px-4 py-2 border-0 rounded relative mb-4 mt-4 bg-green-400">
    <span className="text-xl inline-block mr-5 align-middle">
      <i className="fas fa-check-circle"></i>
    </span>
    <span className="inline-block align-middle mr-8">
      {sessionStorage.getItem("prev_promo_message")} ({sessionStorage.getItem("previlageCardvalue")})
    </span>
  </div> 
  : null
)}

<div className='mb-4'>
  {/* Title above the Promo Code input box */}
  <h3 className='text-primary text-center font-semibold mb-2'>
    Promo Code
  </h3>
  
  <div className='flex'>
    <input
      type="text"
      className='pl-4 w-full border border-r-0 border-primary py-2 px-3 rounded-l-md focus:ring-primary focus:border-primary text-sm'
      placeholder='Coupon'
      value={promoCode}
      onChange={handlePromoCodeChange}
    />
    {sessionStorage.getItem('promoStatusCheck') == 1
      ? <button
          type="submit"
          className='bg-primary border border-primary text-white px-5 font-medium rounded-r-md transition text-sm w-full block text-center'
          onClick={() => {
            sessionStorage.removeItem("promocode");
            sessionStorage.removeItem("promo_final_price");
            sessionStorage.removeItem("discount");
            // promostatus removed when clear - 29/08/2024
            sessionStorage.removeItem("promoStatusCheck");
            sessionStorage.removeItem("promo_message");
            window.location.reload();
          }}
        >
          Remove
        </button>
      : <button
      type="submit"
      className={`bg-primary border border-primary text-white px-5 font-medium rounded-r-md transition text-sm w-full block text-center ${!promoCode ? 'opacity-50 cursor-not-allowed' : ''}`}
      onClick={(event) => theme.siteStatus !== 0 ? handlePromoCodeSubmit(event) : handleDisabledClick1(event)}
      disabled={!promoCode} 
    >
      Apply
    </button>}
  </div>
</div>
{/* message display for promocode - 28/08/2024 */}
{sessionStorage.getItem('promoStatusCheck') !== null && sessionStorage.getItem('promoStatusCheck') !== undefined && (
  sessionStorage.getItem('promoStatusCheck') == 0 ? 
  <div className="text-white px-4 py-2 border-0 rounded relative mb-4 mt-4 bg-red-400">
    <span className="text-xl inline-block mr-5 align-middle">
      <i className="fas fa-exclamation-circle"></i>
    </span>
    <span className="inline-block align-middle mr-8">
      {sessionStorage.getItem("promo_message")} ({promoCodeData})
    </span>
  </div> : 
  sessionStorage.getItem('promoStatusCheck') == 1 ? 
  <div className="text-white px-4 py-2 border-0 rounded relative mb-4 mt-4 bg-green-400">
    <span className="text-xl inline-block mr-5 align-middle">
      <i className="fas fa-check-circle"></i>
    </span>
    <span className="inline-block align-middle mr-8">
      {sessionStorage.getItem("promo_message")} ({promoCodeData})
    </span>
  </div> 
  : null
)}


            <Link href={theme.siteStatus === 0 ? "/checkout/Checkout?pid=" + theme.token : "/checkout/Checkout"}>
              <span className='bg-primary border border-primary text-white px-4 py-3 font-medium rounded-md uppercase hover:bg-transparent hover:text-primary transition text-sm w-full block text-center'>
                Proceed to checkout
              </span>
            </Link>
          </div>
        </div>
      </div>

      <CustomPopup
        isOpen={isPopupOpen}
        type={popupConfig.type}
        title={popupConfig.title}
        subText={popupConfig.subText}
        onConfirm={popupConfig.onConfirm}
        onClose={popupConfig.onClose}
        showConfirmButton={popupConfig.showConfirmButton}
        showCancelButton={popupConfig.showCancelButton}
        autoClose={popupConfig.autoClose}
      />
    </>
  )
}

function sanitizeHostname(host) {
  const hostname = new URL(`https://${host}`).hostname;
  return hostname;
}

const logError = (endpoint, error) => {
  const responseData = error.response?.data ?? '';
  errorLogApi({
    job_id: "",
    endpoint: endpoint,
    payload: '',
    responseData: responseData,
    errorMsg: error
  });
};

function parseCookies(cookieHeader) {
  const cookies = {};
  if (!cookieHeader) return cookies;
  const pairs = cookieHeader.split(';');
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].trim().split('=');
    cookies[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return cookies;
}


export async function getServerSideProps(context) {
  const { req, res } = context;
  const cookies = parseCookies(req.headers.cookie);
  const userDetails = cookies.userDetails ? JSON.parse(cookies.userDetails) : null;
  const hostname = req.headers.host === "localhost:3000" ? process.env.NEXT_PUBLIC_WEB_HOST : sanitizeHostname(req.headers.host);
  const redishostname = sanitizeHostname(req.headers.host);
  const redis = redishostname.startsWith('localhost') ? getRedisClientLocal() : getRedisClient();


  if (!hostname.startsWith('preview.') && !userDetails) {
    const url = req.url;
    res.setHeader("Set-Cookie", `initialReferrer=${url}; Path=/;`)
    return {
      redirect: {
        destination: '/auth/SignIn',
        permanent: false,
      },
    };
  }

  
  const previewUrl = req.headers.host === "localhost:3000"
    ? "https://preview.jpencil.in/?pid=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqYm9faWQiOjIzMywic2l0ZV9zdGF0dXMiOjAsImlhdCI6MTcxNDY0MzI4MX0.QXsuG6PL2rBZP92YZMTeMRnO3at8Sfq2gOf22rG6jeg"
    : req.url;

  const urlObj = new URL(previewUrl, `http://${hostname}`);
  const pid = urlObj.searchParams.get('pid');

  if (hostname.startsWith('preview.')) {
    const innerJson = JSON.stringify({
      domain: hostname,
      token: pid
    });

    const payload = {
      data: innerJson
    };

    try {
      const response = await axios.post(`https://${hostname}/api/user/getJbo`, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      return { props: { products: response.data } };
    } catch (error) {
      logError('getJbo', error);
    }
  }

  try {
    const cachedProducts = await redis.get(hostname);

    if (cachedProducts) {
      return { props: { products: JSON.parse(cachedProducts) } };
    }

    const innerJson = JSON.stringify({ domain: hostname });
    const payload = {
      data: JSON.stringify({ domain: hostname })
    };

    const response = await axios.post(`https://${hostname}/api/user/getJbo`, payload, {
      headers: { 'Content-Type': 'application/json' }
    });

    if (response.data && Object.keys(response.data).length) {
      return { props: { products: response.data } };
    }

    logError('getJbo', new Error('No data returned from API'));
    return { props: { products: [] } };
  } catch (error) {
    logError('getJbo', error);
    return { props: { products: [] } };
  }
}

export default Cart;
